/**
 * Handle accordions.
 */

const accoindionsHandle = function () {
  const $accordion = $('.js-accordion');
  const $accordionSections = $accordion.find('.accordion__section');

  if ( ! $accordion.length) {
    return;
  }

  $accordionSections.each(function () {
    $(this)
      .find('.accordion__head')
      .on('click', function (e) {
        e.preventDefault();
        const $this = $(this);
        const $parent = $this.closest('.accordion__section');
        $parent.toggleClass('is-active');
        $parent.find('.accordion__body').slideToggle();
      });
  });
};

accoindionsHandle();
